/**
 * Fetches the Clerk public key from the backend.
 * @param {string} apiUrl  Base URL of your API (e.g. "http://localhost:8000")
 * @returns {Promise<string>}  The clerk_public_key value
 */

export default async function getClerkPublicKey() {
    const apiUrl = process.env.REACT_APP_API_URL;

    const res = await fetch(`${apiUrl}/api/clerk-public-key-get`);
    if (!res.ok) {
      throw new Error(`Failed to fetch clerk public key: ${res.status} ${res.statusText}`);
    }
    const data = await res.json();
    console.log(`Fetched clerk public key: ${data.clerk_public_key}`);
    return data.clerk_public_key;
  }